import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import Main from './components/Main';
import VModal from 'vue-js-modal';
Vue.use(VueRouter);
Vue.use(VModal, { dynamic: true });

const router = new VueRouter({
  mode: 'history',
  routes: [{ path: '/:hs', component: Main }]
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  components: { App }
}).$mount('#app');
